import { EntityType } from './changeRequest';

// Re-export EntityType for convenience
export { EntityType };

export enum DocumentType {
  IdentityDocument = 1,
  ProofOfAddress = 2,
  ProfessionalCertificate = 3,
  FoundationAct = 4,
  Other = 5,
  CV = 6,
  ProfessionalActivityDocuments = 7,
  StudentID = 8,
  PetitionAttachment = 10,
}

export interface Document {
  id: string;
  userId: string;
  entityType: EntityType;
  entityId: string;
  documentType: DocumentType;
  fileName: string;
  originalFileName: string;
  fileSize: number;
  contentType: string;
  uploadedAt: string;
  isVerified: boolean;
}

export interface DocumentUpload {
  file: File;
  documentType: DocumentType;
  entityType: EntityType;
  entityId: string;
}
